import { useState } from "react";

import { useTimeout } from "usehooks-ts";

import { EntityPill } from "src/copilot/EntityPill";
import { EntitySchemaResource } from "src/entities/queries";

type Props = {
  entity: EntitySchemaResource;
  delay: number;
};

export const EntityMention = ({ entity, delay }: Props) => {
  const [render, setRender] = useState(delay ? false : true);

  useTimeout(() => setRender(true), 1000 * delay);

  return (
    render && (
      <span className="mx-1 inline-flex">
        <EntityPill resource={entity} />
      </span>
    )
  );
};
